import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewExit() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New exit case"
      listPath="/panel/exits"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'employeeId', label: 'Employee', required: true },
            { key: 'reason', label: 'Reason', type: 'select', required: true, options: [
              { value: 'resignation', label: 'Resignation' },
              { value: 'termination', label: 'Termination' },
              { value: 'retirement', label: 'Retirement' },
              { value: 'absconding', label: 'Absconding' },
              { value: 'contract-end', label: 'Contract end' },
            ] },
            { key: 'noticeDate', label: 'Notice given on', type: 'date', required: true },
            { key: 'lastWorkingDate', label: 'Last working date', type: 'date', required: true },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'noticePeriodDays', label: 'Notice period (days)', type: 'number' },
            { key: 'shortfallDays', label: 'Notice shortfall (days)', type: 'number' },
            { key: 'managerComments', label: 'Manager comments', type: 'textarea' },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [
            { key: 'resignationLetterUrl', label: 'Resignation letter URL' },
            { key: 'clearanceStatus', label: 'Clearance status', type: 'select', options: [
              { value: 'pending', label: 'Pending' },
              { value: 'partial', label: 'Partial' },
              { value: 'cleared', label: 'Cleared' },
            ] },
            { key: 'exitInterviewNotes', label: 'Exit interview notes', type: 'textarea' },
          ],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
